import { useState, useEffect } from 'react'
import axios from 'axios'
import { useLocale } from 'hooks'

export const useCountrySubdivisionList = ({
  countryCode
}: UseCountryListOptions) => {
  const { localiseUrl } = useLocale()

  const [subdivisons, setSubdivisons] = useState<SubdivionProps[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)

  const apiUrl = localiseUrl(
    `/api/countries/subdivisions?country=${countryCode}`,
    {
      localeAsParam: true
    }
  )

  useEffect(() => {
    if (!countryCode) return

    const fetchData = async () => {
      try {
        setLoading(true)

        const response = await axios.get(apiUrl)
        const { data } = response

        setSubdivisons(data.subdivisions)
      } catch (error) {
        setError('Error fetching subdivision list')
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [countryCode, apiUrl])

  return { subdivisons, loading, error }
}

interface UseCountryListOptions {
  countryCode?: string
}

export interface SubdivionProps {
  code: string
  display_name: string
  gb_name: string
  official_name: string
}
